import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SimButtonModule } from '@simOn/ui/sim-button';

@Component({
  selector: 'sim-filter-actions',
  imports: [SimButtonModule],
  templateUrl: './filter-actions.component.html',
  styleUrl: './filter-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'filter-actions'
  }
})
export class SimFilterActionsComponent {
  readonly count = input<number>(0);
  readonly clearDisabled = input<boolean>(false);
  readonly applyDisabled = input<boolean>(false);

  readonly clear = output<void>();
  readonly apply = output<void>();

  protected onClear(): void {
    this.clear.emit();
  }

  protected onApply(): void {
    this.apply.emit();
  }
}
